import React from "react";
import PreviousDayPerfomance from "./perfomance/PreviousDayPerfomance";
import PreviousDayWinners from "./winners/PreviousDayWinners";
import { useSettings } from "../../hooks/useSettings";
import { formatLabel } from "../../utilities/string";

const PreviousDayPrediction = (prop) => {
  const settings = useSettings();

  const matchDay = formatLabel(prop?.question?.group_label) 

  return (
    <div>
       <PreviousDayWinners
        leaderboard={
          prop.question.leader_board
            ? prop.question.leader_board[0].winners
            : ""
        }
        day={matchDay}
      />
      <PreviousDayPerfomance
        scoreProfile={prop.question.user_score_profile}
        questions={prop.question.data}
        day={matchDay}
      />
    </div>
  );
};

export default PreviousDayPrediction;
